(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["split-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('partner-quote-modal')) {
    customElements.define(
      'partner-quote-modal',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;

          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          this.controller = new AbortController();
          const options = { signal: this.controller.signal };

          this.unlockScroll = () => {
            if (!this.scrollLocked) return;
            document.body.style.overflow = this.previousOverflow;
            this.scrollLocked = false;
          };

          document.addEventListener('click', (event) => {
            const trigger = event.target.closest(
  '[data-partner-quote-open], a[href="#partner-quote"]'
);

if (!trigger) return;

const matchesModal =
  trigger.dataset.partnerQuoteOpen === this.dialog.id ||
  trigger.getAttribute('href') === '#partner-quote';

if (!matchesModal) return;

            event.preventDefault();
            if (this.dialog.open) return;

            this.dialog.showModal();
            this.dialog.scrollTop = 0;
            this.previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            this.scrollLocked = true;
          }, options);

          this.querySelector('[data-partner-quote-close]')
            .addEventListener('click', () => {
              this.dialog.close();
            }, options);

          this.dialog.addEventListener('click', (event) => {
            if (event.target !== this.dialog) return;

            const bounds = this.dialog.getBoundingClientRect();
            const outside =
              event.clientX < bounds.left ||
              event.clientX > bounds.right ||
              event.clientY < bounds.top ||
              event.clientY > bounds.bottom;

            if (outside) this.dialog.close();
          }, options);

          this.dialog.addEventListener(
            'close',
            this.unlockScroll,
            options
          );
        }

        disconnectedCallback() {
          if (this.dialog?.open) this.dialog.close();
          this.unlockScroll?.();
          this.controller?.abort();
          this.controller = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
